// eslint-disable-next-line no-control-regex
export const EMAIL_REGEX = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,}$/;

export const PASSWORD_HAS_DIGITS_REGEX = /\d+/;

export const PASSWORD_HAS_LOWERCASE_CHARS_REGEX = /[a-z]+/;

export const PASSWORD_HAS_UPPERCASE_CHARS_REGEX = /[A-Z]+/;

export const DOES_NOT_CONTAIN_WHOPPAH_REGEX = /^(?!.*whoppah).*$/gi;

export const CONTAINS_NUMBER_REGEX = /\d/;
